import { PlateListSimple } from "./PlateListSimple";
import { PlateListWithPagination } from "./PlateListWithPagination";
import { observer } from "mobx-react-lite";

type PlateListWithPaginationProps<T, S> = Parameters<typeof PlateListWithPagination<T, S>>[0];

interface PlateListProps<T, S> extends PlateListWithPaginationProps<T, S> {
  showPagination?: boolean;
}

export const PlateList = observer(
  <T, S>({
    errorMessage = "Ошибка загрузки данных",
    showPagination = false,
    pageSizeOptions,
    ...restProps
  }: PlateListProps<T, S>) => {
    if (showPagination) {
      return (
        <PlateListWithPagination
          errorMessage={errorMessage}
          emptyProps={{ description: "Данные не найдены" }}
          pageSizeOptions={pageSizeOptions}
          {...restProps}
        />
      );
    }

    return <PlateListSimple errorMessage={errorMessage} {...restProps} />;
  }
);
